import {Component} from 'react';
import PropTypes from 'prop-types';
import EditableTitle from './EditableTitle';
import {Form, Header, Segment} from 'semantic-ui-react';
import ComparableItemMap from './ComparableItemMap';
import capitalize from 'lodash/capitalize';
import {DisclaimerText} from 'components/DisclaimerText';

export default class CustomiseComparableItemMap extends Component {
  static propTypes = {
    markers: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string.isRequired,
      lat: PropTypes.number.isRequired,
      lng: PropTypes.number.isRequired,
      sla: PropTypes.string.isRequired,
      beds: PropTypes.number,
      baths: PropTypes.number,
      cars: PropTypes.number,
      daysOnMarket: PropTypes.number,
      salePrice: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }).isRequired),
    targetLatLng: PropTypes.shape({
      lat: PropTypes.number.isRequired,
      lng: PropTypes.number.isRequired,
    }).isRequired,
    center: PropTypes.shape({
      lat: PropTypes.number.isRequired,
      lng: PropTypes.number.isRequired,
    }),
    zoom: PropTypes.number,
    title: PropTypes.string.isRequired,
    reportType: PropTypes.string.isRequired,
    comparableType: PropTypes.string.isRequired,
    updateSectionValue: PropTypes.func.isRequired,
    updatePreferences: PropTypes.func.isRequired,
    onMapZoomChange: PropTypes.func.isRequired,
    onMapCenterChange: PropTypes.func.isRequired,
  };

  render() {
    const {
      markers,
      center,
      zoom,
      targetLatLng,
      title,
      reportType,
      updateSectionValue,
      updatePreferences,
      onMapZoomChange,
      onMapCenterChange,
      comparableType,
    } = this.props;

    return (
      <div className="comparable-item-map">
        <Header as="h2" className="section-type" style={{fontWeight: 'bold'}} disabled>
          {`Comparables ${capitalize(comparableType)} Map - Max. 10 properties displayed`}
        </Header>
        <Segment style={{padding: '30px'}}>
          <Header as="h3">
            <span className="disabled">Title</span>
            <DisclaimerText/>
          </Header>
          <Form className="sectionData">
            <Form.Group inline>
              <EditableTitle
                onUpdateData={(data) => {
                  updateSectionValue(data.title, 'title');
                  updatePreferences({[`comparable${capitalize(comparableType)}Map.sectionData.title`]: data.title}, reportType);
                }}
                isEnabled={true}
                maxLength={32}
                width="50%"
                title={title}/>
            </Form.Group>
          </Form>
          <ComparableItemMap
            center={center}
            zoom={zoom}
            markers={markers}
            targetLatLng={targetLatLng}
            onMapZoomChange={onMapZoomChange}
            onMapCenterChange={onMapCenterChange}
            comparableType={comparableType}
          />
        </Segment>
      </div>
    );
  }
}